import { makeStyles } from '@material-ui/core';
import React, { useMemo } from 'react';
import parse from 'html-react-parser';

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
    },
    descFieldName: {
        fontSize: '20px',
        fontWeight: '400',
        color: theme.palette.primary.main,
        whiteSpace: 'nowrap',
        marginRight: '6px',
    },
    descValue: {
        fontSize: '20px',
        fontWeight: '400',
        whiteSpace: 'pre-wrap',
        lineHeight: '100%',
        marginTop: '10px',
    },
    containerMultiValues: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        flexWrap: 'wrap',
    },
    hasFileAnchorUrl: {
        textDecoration: 'underline !important',
        textDecorationThickness: '1px !important',
        textUnderlineOffset: '2px !important',
    },
    htmlDetail: {
        padding: '0px',
        overflow: 'hidden',
    },
}));

const EventFieldDescription = (props) => {
    const {
        fieldName,
        className,
        value,
        download = false,
        isHtml = false,
    } = props;
    const classes = useStyles();
    const isArray = useMemo(() => {
        return Array.isArray(value);
    }, [value]);
    if (download) {
        return (
            <div className={`${classes.containerMultiValues} ${className}`}>
                <span className={classes.descFieldName}>
                    {fieldName ? fieldName + ':' : ''}
                </span>
                <span>
                    {value ? (
                        <a
                            href={value.url}
                            className={classes.hasFileAnchorUrl}
                        >
                            {value.name}
                        </a>
                    ) : (
                        '-'
                    )}
                </span>
            </div>
        );
    } else if (isArray) {
        return (
            <div className={`${classes.containerMultiValues} ${className}`}>
                <span className={classes.descFieldName}>
                    {fieldName ? fieldName + ':' : ''}
                </span>
                {value.length > 0 &&
                    value.map((e, index) => {
                        return (
                            <span key={e} className={classes.descValue}>
                                {e}
                                {index < value.length - 1 && ',\u00A0'}
                            </span>
                        );
                    })}
            </div>
        );
    } else if (isHtml) {
        return (
            <div className={`${classes.containerMultiValues} ${className}`}>
                <span className={classes.descFieldName}>
                    {fieldName ? fieldName + ':' : ''}
                </span>
                <span
                    className={`${classes.descValue} ql-editor ${classes.htmlDetail}`}
                >
                    {value && value !== '<p><br></p>' ? parse(value) : '-'}
                </span>
            </div>
        );
    } else {
        return (
            <div className={`${classes.container} ${className}`}>
                <span className={classes.descFieldName}>
                    {fieldName ? fieldName + ':' : ''}
                </span>
                <span className={classes.descValue}>{value ? value : ''}</span>
            </div>
        );
    }
};

export default EventFieldDescription;
